<template>
  <div id="app">
    <Home v-if="currentType === 'hash' && $route.path !== '/login'"></Home>
    <router-view v-else></router-view>
  </div>
</template>
<script>
import Home from "./views/home/home.vue";

export default {
  name: "app",
  components: { Home },
  data() {
    return {
      currentType: "hash",
    };
  },
  created() {
    const __qiankun__ = window.__POWERED_BY_QIANKUN__;
    this.currentType = __qiankun__ ? "history" : "hash";
  },
};
</script>
<style>
html,
body {
  height: 100%;
  overflow: hidden;
  transform: translateZ(0);
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  width: 100%;
  height: 100%;
}
.isRed {
  color: #CA4E49 !important;
}
</style>
